import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
import dynamic from 'next/dynamic';
import { useEffect, useState } from 'react';
import { getFilePreviewType } from '../../../utils/file-preview-type';
import { isPastedText } from '../../../utils/pasted-text';
const PdfThumbnail = dynamic(() => import('./pdf-thumbnail'), {
  ssr: false
});
const TextThumbnail = t0 => {
  const $ = _c(11);
  const {
    file,
    fallback
  } = t0;
  const [preview, setPreview] = useState(null);
  let t1;
  let t2;
  if ($[0] !== file) {
    t1 = () => {
      if (isPastedText(file)) {
        return;
      }
      const reader = new FileReader();
      reader.onload = () => setPreview({
        file,
        text: typeof reader.result === "string" ? reader.result : null
      });
      reader.onerror = () => setPreview({
        file,
        text: null
      });
      reader.readAsText(file.slice(0, 8192));
      return () => {
        if (reader.readyState === FileReader.LOADING) {
          reader.abort();
        }
      };
    };
    t2 = [file];
    $[0] = file;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] !== file || $[4] !== preview) {
    t3 = isPastedText(file) ? file.content : preview?.file === file ? preview.text : undefined;
    $[3] = file;
    $[4] = preview;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const text = t3;
  if (text === null || text === "") {
    return fallback;
  }
  if (text === undefined) {
    let t4;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Shimmer className="h-full w-full" />;
      $[6] = t4;
    } else {
      t4 = $[6];
    }
    return t4;
  }
  let t4;
  if ($[7] !== text) {
    t4 = text.slice(0, 8192);
    $[7] = text;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <pre className="h-[200%] w-[200%] origin-top-left scale-50 overflow-hidden whitespace-pre-wrap break-words p-5 text-snippet-3 text-secondary">{t4}</pre>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};
type AttachmentThumbnailProps = {
  file: File;
  extension: string;
};
const AttachmentThumbnail = t0 => {
  const $ = _c(21);
  const {
    file,
    extension
  } = t0;
  let t1;
  if ($[0] !== file.name || $[1] !== file.type) {
    t1 = getFilePreviewType(file.name, file.type);
    $[0] = file.name;
    $[1] = file.type;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const kind = t1;
  const [preview, setPreview] = useState(null);
  const [failedImage, setFailedImage] = useState(null);
  let t2;
  let t3;
  if ($[3] !== file || $[4] !== kind) {
    t2 = () => {
      if (kind !== "image") {
        return;
      }
      const url = URL.createObjectURL(file);
      setPreview({
        file,
        url
      });
      return () => URL.revokeObjectURL(url);
    };
    t3 = [file, kind];
    $[3] = file;
    $[4] = kind;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  let t4;
  if ($[7] !== extension) {
    t4 = <div className="flex h-full w-full items-center justify-center px-3"><span className="truncate text-heading-3 text-quaternary">{extension}</span></div>;
    $[7] = extension;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const fallback = t4;
  if (kind === "pdf") {
    let t5;
    if ($[9] !== fallback || $[10] !== file) {
      t5 = <PdfThumbnail file={file} fallback={fallback} />;
      $[9] = fallback;
      $[10] = file;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    return t5;
  }
  if (kind === "text") {
    let t5;
    if ($[12] !== fallback || $[13] !== file) {
      t5 = <TextThumbnail file={file} fallback={fallback} />;
      $[12] = fallback;
      $[13] = file;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  if (kind !== "image" || failedImage === file) {
    return fallback;
  }
  if (preview?.file !== file) {
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <Shimmer className="h-full w-full" />;
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    return t5;
  }
  let t5;
  if ($[16] !== file) {
    t5 = () => setFailedImage(file);
    $[16] = file;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== preview.url || $[19] !== t5) {
    t6 = <img src={preview.url} alt="" className="h-full w-full object-cover" onError={t5} />;
    $[18] = preview.url;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default AttachmentThumbnail;